import type { ReadonlyRecord } from '../utils'

import type { ConnectwareError } from './Error'

export enum ResourceType {
    AGENT = 'AGENT',
    CONNECTION = 'CONNECTION',
    CORE_CONTAINER = 'CORE_CONTAINER',
    ENDPOINT = 'ENDPOINT',
    MAPPING = 'MAPPING',
    SERVER = 'SERVER',
    SERVICE = 'SERVICE',
    SERVICE_CONTAINER = 'SERVICE_CONTAINER',
    VOLUME = 'VOLUME',
}

export type ResourceActionType = 'delete' | 'disable' | 'enable' | 'reenable'

type ResourceState = Readonly<{
    ids: readonly string[] | null
    /**
     * If loading then true
     * If not loading then false
     * If last load yielded an error then {ConnectwareError}
     */
    load: ConnectwareError | boolean
}>

export type ResourcesAppState = Readonly<{ resources: ReadonlyRecord<ResourceType, ReadonlyRecord<ResourceActionType, ResourceState>> }>

export const selectResources = (s: ResourcesAppState): ResourcesAppState['resources'] => s.resources

export const selectResourcesByDimensionAndAction = (s: ResourcesAppState, dimension: ResourceType, action: ResourceActionType): ResourceState =>
    selectResources(s)[dimension][action]
